import { useState } from 'react';
import { api } from '@/utils/api';
export function DealerRequestActions({ id, onSaved }: { id: string; onSaved: () => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function decide(action: 'approve' | 'reject') {
    const decisionNote = action === 'reject' ? window.prompt('Reason for rejecting this request') : undefined;
    if (decisionNote === null) return;
    setBusy(true); setError(null);
    try { await api.patch(`/dealer-access-requests/${id}`, { action, ...(decisionNote ? { decisionNote } : {}) }); onSaved(); }
    catch (e: any) { setError(e?.response?.data?.error ?? 'Could not save this decision.'); }
    finally { setBusy(false); }
  }
  return <div className="flex flex-wrap gap-2"><button disabled={busy} onClick={() => decide('approve')} className="rounded bg-green-700 px-3 py-1 text-white">Approve</button><button disabled={busy} onClick={() => decide('reject')} className="rounded border px-3 py-1">Reject</button>{error && <p role="alert">{error}</p>}</div>;
}
